<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'App.Admin.Dashboard.Labels.VolumeTrend' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-analytics-chart
      chartType="bar-stacked"
      [data]="chart"
      [grain]="grain"
      [scheme]="scheme"
      [height]="300"
      [legend]="true"
      [toggleableLegend]="true">
    </app-analytics-chart>
  </mat-card-content>
</mat-card>
